import { render, staticRenderFns } from "./QuestionIconGreen.vue?vue&type=template&id=060890be&scoped=true&"
import script from "./QuestionIconGreen.vue?vue&type=script&lang=js&"
export * from "./QuestionIconGreen.vue?vue&type=script&lang=js&"
import style0 from "./QuestionIconGreen.vue?vue&type=style&index=0&id=060890be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060890be",
  null
  
)

export default component.exports